module.exports = __webpack_public_path__ + "img/checksum_go_dl_mac.ae0ba310.png";